import { Component, inject, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IconModule, SimpleInputModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipComponent } from '@iw/common';
import { ProfileService } from '@iw/core/services';
import { environment } from '@iw/environment';

@Component({
  selector: 'iw-code-office-form',
  styleUrl: './code-office-form.component.scss',
  templateUrl: './code-office-form.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SimpleInputModule,
    TranslateModule,
    IconModule,
    TooltipComponent,
  ],
})
export class CodeOfficeFormComponent {
  readonly #profileService = inject(ProfileService);

  readonly me = this.#profileService.me;

  form = input<FormGroup>();

  supportLink = environment.supportLink;
}
